module.exports = __webpack_public_path__ + "img/pause-icon-audio.d076c3c7.svg";